import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from 'react-icons/io';

const HomeWrap = styled.div`
.article2 {
    .row { 
            h2 {
                font-size:20px; padding-top:30px;
            }
        .local {
            display: flex;
            flex-wrap: wrap;
            padding: 30px 0;
            li {
                width: 33.33%; padding:20px;
                a { display: flex; align-items: center;
                    img { width: 50%; margin-right: 10px;
                            border-radius: 10px;
                    }
                }
            }
        }
        .lifeStyle {
            h2 { font-size: 20px;}
            ul { 
                display:flex;
                li { 
                    flex: 1; padding: 20px 20px 20px 0;
                    &:last-child { padding-right: 0px;}
                }
            }
        }
    }
}

.article3 {
    background: #000;
    padding: 100px 0;
    color: #fff;
    .row { display: flex; justify-content: space-between; 
        div.rowchild { width: 52%; 
            img { border-radius: 40px 40px 0px 0px; }
            p { background: #999;
                border-radius: 0px 0px 40px 40px;
                padding: 20px;
             }
            &.right { width: 46%;
                display: flex; flex-direction: column;
                justify-content: space-between;
                .rightRow1 { display: flex; justify-content: space-between;
                    div { width: 49%;}
                }
            }
        }
    }
}
`
const Article1 = styled.div`
    position:relative;
   .slide {
        position:relative;
        height: 30vw;
        background-size: cover;
        background-repeat: no-repeat;
        background-position:bottom;
        &.slide1 { background-image:url('images/bg11.jpeg') };
        &.slide2 { background-image:url('images/bg33.jpeg') };
        &.slide3 { background-image:url('images/bg22.jpeg') };
        .text {
            position:absolute; left:50%; text-align:center;
            top:50%; transform:translate(-50%, -50%);
            color:#fff; font-size:30px;
            button { padding:10px; border:none; background:#fff; border-radius:10px;}
        }
    }

    .slick-arrow { position:absolute; top:50%; transform:translateY(-50%);
        background:none; padding:10px; z-index:9999; width:60px; height:60px; color:green;
        &.slick-prev { left:100px;  }
        &.slick-next { right:100px;  }    
    }

    .slick-dots { position:absolute; bottom:30px; left:50%; transform:translate(-50%);
        li { display:inline-block; padding:0 5px; 
            button { width:30px; height:30px; border-radius:50%; background:#fff;
                text-indent:-9999px; overflow:hidden }
        &.slick-active { button { background:green} }
        }
    }
`;

const Homesection = () => {

    const settings = {
        dots:true,
        infinite:true,
        speed:600,
        autoplay:true,
        autoplaySpeed:4000,
        slidesToShow:1,
        slidesToScroll:1,
        prevArrow: <IoIosArrowDropleftCircle />,
        nextArrow: <IoIosArrowDroprightCircle />
    }

    return (
        <HomeWrap>
            <Article1 className="article1">
                <Slider {...settings}>
                    <div className="slide slide1">
                        <div className="text">
                            <p>Pick your favorite</p>
                            <button>자세히 보기</button>
                        </div>
                    </div>
                    <div className="slide slide2">
                        <div className="text">
                            <p>Carry the Merry</p>
                            <button>자세히 보기</button>
                        </div>
                    </div>
                    <div className="slide slide3">
                        <div className="text">
                            <p>이제, 스타벅스를 가까이에서 경험해보세요</p>
                            <button>매장 찾기</button>
                        </div>
                    </div>
                </Slider>
            </Article1>
            <div className="article2">
                <div className="row">
                    <h2>RESERVE MAGAZINE</h2>
                    <ul className="local">
                        <li>
                            <a href="#">
                                <img src="./images/ma1.jpeg" alt="" />
                                <div>
                                    <strong>STEP 4｜리저브에서 취향을 더해보세요</strong>
                                    <p>커피를 만드는 바리스타이자,새로운커피를 안내하는 스타벅스..</p>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src="./images/ma2.jpeg" alt="" />
                                <div>
                                    <strong>STEP 3｜리저브 에스프레소 즐기기</strong>
                                    <p>에스프레소만큼 현대인들이 다양한 취향으로 즐기는 커피가 있을까?..</p>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src="./images/ma3.jpeg" alt="" />
                                <div>
                                    <strong>STEP 2｜다양한 리저브 추출 방법</strong>
                                    <p>사람들은 커피를'현대인의 필수품'이라고 말한다..</p>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src="./images/ma4.jpeg" alt="" />
                                <div>
                                    <strong>Issue 2 │ Trip to Reserve : 커피로 시..</strong>
                                    <p>커피를 고르라고 하면 무의식적으로 아메리카노와 라떼 중에서 고른다.하지만..</p>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src="./images/ma5.jpeg" alt="" />
                                <div>
                                    <strong>Issue 2 │ Trip to Reserve : 도심에서 떠나..</strong>
                                    <p>커피 향 가득한 매장에 들어서는 순간 듣게 되는 켱쾌한 인사말이다..</p>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <img src="./images/ma6.jpeg" alt="" />
                                <div>
                                    <strong>그린 사이렌 클래식 머그 355ml</strong>
                                    <p>키다리 마천루와 키작은 고옥이 공존하는 서울의 도심,종로한가운데 스타벅스 더종로R점이 있다..</p>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <div className="lifeStyle">
                        <h2>10월 21일, 리저브 크리스마스 신규 커피원두 출시</h2>
                        <ul>
                            <li>
                                <img src="./images/ss1.png" alt="" />
                                <strong>CHRIST MAS 2021</strong>
                            </li>
                            <li>
                                <img src="./images/ss2.png" alt="" />
                                <strong>RWANDA SHOLI</strong>
                            </li>
                            <li>
                                <img src="./images/ss3.png" alt="" />
                                <strong>ZAMBIA ISANYA ESTATE</strong>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="article3">
                <div className="row">
                    <div className="rowchild left">
                        <img src="./images/fu1.png" alt="" />
                        <p>원두 취향 설명서</p>
                    </div>
                    <div className="rowchild right">
                        <div className="rightRow1">
                            <div>
                                <img src="./images/fu2.png" alt="" />
                                <p>다양한 리저브 추출 방법</p>
                            </div>
                            <div>
                                <img src="./images/fu3.png" alt="" />
                                <p>리저브 에스프레소 즐기기</p>
                            </div>
                        </div>
                        <div className="rightRow2">
                                <img src="./images/fu4.png" alt="" />
                                <p>리저브에서 취향을 더해보세요</p>
                        </div>
                    </div>
                </div>
            </div>
        </HomeWrap>
    );
};

export default Homesection; 